function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.018 34.131V33.3l1.662-1.663v-4.988a5.82 5.82 0 014.157-5.579v-.24a1.663 1.663 0 013.326 0v.24a5.819 5.819 0 014.156 5.579v.898l-.831-.067a4.993 4.993 0 00-4.706 6.651h-7.764zm7.482 2.494a1.663 1.663 0 01-1.663-1.663h2.328c.2.341.44.657.707.94-.3.44-.799.723-1.372.723z",
  fill: "#0073FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.17 29.224a.362.362 0 00-.675-.183L30.96 33.39a.362.362 0 00.313.545h1.45v2.537a.362.362 0 00.675.183l2.536-4.349a.364.364 0 00-.132-.496.363.363 0 00-.181-.049h-1.45v-2.536z",
  fill: "#0073FF",
  fillOpacity: 0.3
});

var SvgRemindActive = function SvgRemindActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgRemindActive;